import { defineStore } from 'pinia'
import { MENU_CODE } from '~/constants/menu'

export const useMenuStore = defineStore('menu', () => {
  const list = ref<Menu[]>([])
  const allList = ref<Menu[]>([])
  const { $api } = useNuxtApp()

  const fetch = async () => {
    const response = await $api<ApiSuccessResponse<Menu[]>>('/menus')
    const data = response.data
    if (data) {
      update(data)
    }
  }

  const update = (payload: Menu[]) => {
    const orderedMenus = [...payload].sort((a, b) => a.position - b.position)
    const isHomeNotHasTitle = payload.some(menu => menu.title === '' && menu.code === MENU_CODE.HOME)
    list.value = orderedMenus.filter((menu) => {
      if (menu.code === MENU_CODE.HOME) {
        return true
      }
      if (menu.code === MENU_CODE.EXTERNAL_LINK) {
        return !isHomeNotHasTitle && !!menu.title && !!menu.externalLink?.trim()
      }
      if (menu.code === MENU_CODE.GALLERY_REVIEW) {
        return !isHomeNotHasTitle && !!menu.title && !!menu.subMenus?.some(
          subMenu => !!subMenu.title && !!subMenu.slug,
        )
      }
      return isHomeNotHasTitle ? false : menu.title !== '' && menu.slug !== ''
    }).map((menu) => {
      const mapped = {
        ...menu,
        metaTitleFront: menu.metaTitleFront || menu.metaTitle,
        metaDescriptionFront: menu.metaDescriptionFront || menu.metaDescription,
      }
      const subMenu = mapped.subMenus
      if (subMenu && Array.isArray(subMenu)) {
        return {
          ...mapped,
          subMenus: subMenu.filter(subMenu => subMenu.slug !== '' && subMenu.title !== ''),
        } as Menu
      }
      return mapped
    })
    allList.value = orderedMenus
  }
  return {
    list,
    allList,
    fetch,
    update,
  }
})
